<template>
  <div class="rpt-content">
    <div class="search-box">
      <div class="search-control-item">
        <el-input v-model="inputValue" placeholder="请输入内容" class="input-with-select" style="width: 440px;">
          <el-select style="width: 170px;" v-model="selectType" slot="prepend" placeholder="请选择">
            <el-option label="企业名称" value="company_name"></el-option>
            <el-option label="统一社会信用代码" value="credit_code"></el-option>
            <el-option label="海关编号" value="customs_code"></el-option>
          </el-select>
        </el-input>
      </div>
      <!-- <el-date-picker
        class="search-control-item"
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
      ></el-date-picker> -->
      <el-select v-model="apply_date" class="search-control-item" clearable style="width: 120px;" placeholder="年份">
        <el-option label="今年" value="2021"></el-option>
        <el-option label="去年" value="2020"></el-option>
        <el-option label="前年" value="2019"></el-option>
      </el-select>
      <el-select v-model="i_e_flag" class="search-control-item" clearable style="width: 120px;" placeholder="进出口类型">
        <el-option label="I" value="I"></el-option>
        <el-option label="E" value="E"></el-option>
      </el-select>
      <el-select v-model="trade_mode" class="search-control-item" clearable style="width: 140px;" placeholder="贸易方式">
        <el-option label="一般贸易" :value="0"></el-option>
        <el-option label="非一般贸易" :value="1"></el-option>
      </el-select>
      <region class="search-control-item" v-model="regionId" />
      <el-button class="search-control-item" type="primary" icon="el-icon-search" @click="search('btn')">查询</el-button>
      <!-- <el-button class="search-control-item" type="text" icon="el-icon-download">导出</el-button> -->
    </div>

    <el-table border v-loading="tableloading" :data="tableData" style="width: 100%" max-height="700">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="company_name" width="300" label="企业名称"></el-table-column>
      <el-table-column prop="credit_code" width="150" label="统一社会信用代码"></el-table-column>
      <el-table-column prop="province_name" label="所在省份"></el-table-column>
      <el-table-column prop="city_name" label="所在城市"></el-table-column>
      <el-table-column prop="area_name" label="所在区域"></el-table-column>
      <el-table-column prop="customs_code" label="海关编号"></el-table-column>
      <el-table-column prop="i_e_flag" label="进出口标识"></el-table-column>
      <el-table-column prop="usd_total_amt" label="总货值（美元）"></el-table-column>
      <el-table-column prop="rmb_total_amt" label="总货值（人民币）"></el-table-column>
      <el-table-column prop="apply_date" label="年份"></el-table-column>
      <el-table-column prop="trade_mode" label="贸易方式">
        <template slot-scope="scope">
          <span>{{ scope.row.trade_mode == 1 ? '非一般贸易' : '一般贸易' }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[50, 100, 200, 300]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request';
export default {
  name: 'statistics',
  data() {
    return {
      tableloading: false,
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      tableData: [],

      date: [],
      apply_date: '',
      i_e_flag: '',
      trade_mode: '',
      selectType: 'company_name',
      inputValue: '',
      regionId: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '前年',
            onClick(picker) {
              const now = new Date();
              const start = new Date(`${now.getFullYear() - 2}/1/1`);
              const end = new Date(`${now.getFullYear() - 2}/12/31`);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '去年',
            onClick(picker) {
              const now = new Date();
              const start = new Date(`${now.getFullYear() - 1}/1/1`);
              const end = new Date(`${now.getFullYear() - 1}/12/31`);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '今年',
            onClick(picker) {
              const now = new Date();
              const start = new Date(`${now.getFullYear()}/1/1`);
              picker.$emit('pick', [start, now]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.search();
    },
    handleCurrentChange(index) {
      this.pageIndex = index;
      this.search();
    },
    search(type) {
      if (type == 'btn') this.pageIndex = 1;
      let data = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        apply_date: this.apply_date,
        i_e_flag: this.i_e_flag,
        trade_mode: this.trade_mode,
        province_id: this.regionId[0] || '',
        city_id: this.regionId[1] || '',
        area_id: this.regionId[2] || ''
      };
      data[this.selectType] = this.inputValue;

      request({ url: `/api/rpt/company/goods/amt/count`, data }).then(res => {
        if (res.success) {
          this.tableData = res.result.companyGoodsTotalCountList;
          this.total = res.result.recordCount;
        }
      });
    }
  }
};
</script>

<style></style>
